import FixtureInfo from "./FixtureInfo";
export default FixtureInfo;
